import { render, staticRenderFns } from "./erpLogin.vue?vue&type=template&id=0cf0b719&"
import script from "./erpLogin.vue?vue&type=script&lang=js&"
export * from "./erpLogin.vue?vue&type=script&lang=js&"
import style0 from "./erpLogin.vue?vue&type=style&index=0&id=0cf0b719&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports